(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'metapod', '../config/style'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('metapod'), require('../config/style'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.metapod, global.style);
    global.main = mod.exports;
  }
})(this, function (exports, _metapod, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _metapod2 = _interopRequireDefault(_metapod);

  var StyleConfig = _interopRequireWildcard(_style);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function () {
    return _metapod2.default.div(_metapod2.default.div(_metapod2.default.span({ className: StyleConfig.MESSAGE_CLASS }), _metapod2.default.a('x', {
      href: '#',
      className: StyleConfig.CLOSE_CLASS
    }), { className: StyleConfig.CONTAINER_CLASS }), { className: StyleConfig.NOTIFY_CLASS });
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/klicknotify/lib/views/main.js
// module id = 250
// module chunks = 0